import { createActionTypes } from 'utils/action/actionTypes';

export const CREATE_SCHEDULE = createActionTypes('CREATE_SCHEDULE');
export const FETCH_SCHEDULE = createActionTypes('FETCH_SCHEDULE');
export const GET_SCHEDULE = createActionTypes('GET_SCHEDULE');
export const DELETE_SCHEDULE = createActionTypes('DELETE_SCHEDULE');
export const UPDATE_SCHEDULE = createActionTypes('UPDATE_SCHEDULE');
